<template>
  <div class="cancel-reason">
    <div>
      <img src="../assets/Sad_Bird.png" alt="cancel-reason" class="logo" />
    </div>
    <h1>Why are you thinking about canceling?</h1>

    <div>
      <template v-for="(reason, index) in reasons">
        <option-button
          :text="reason"
          :key="reason"
          @itemSelected="selectReason(index)"
          :isSelected="reasonSelected.includes(index)"
          >{{ reason }}</option-button
        >
      </template>
      <reason-text-area
        placeholder="Other (start typing)"
        @textChange="reasonUpdate"
      />
    </div>
  </div>
</template>

<script>
import OptionButton from "@/components/OptionButton";
import ReasonTextArea from "@/components/ReasonTextArea";

export default {
  name: "CancelReason",
  components: {
    OptionButton,
    ReasonTextArea,
  },
  props: ["reasons", "cancelCta"],
  data() {
    return {
      reasonSelected: [],
      cancelReason: "",
    };
  },
  mounted() {
    this.reasonSelected = [];
  },
  computed: {
    allReasons() {
      let reasons = this.reasonSelected.map((i) => this.reasons[i]);
      if (this.cancelReason) {
        reasons.push(this.cancelReason);
      }
      return reasons;
    },
  },
  methods: {
    reasonUpdate(val) {
      this.cancelReason = val;
      this.$emit("reasonSelected", this.allReasons);
    },
    selectReason(index) {
      if (this.reasonSelected.includes(index)) {
        let i = this.reasonSelected.indexOf(index);
        this.reasonSelected.splice(i, 1);
      } else {
        this.reasonSelected.push(index);
      }
      this.$emit("reasonSelected", this.allReasons);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/mixins";
@import "@/style/variables.scss";

.cancel-reason {
  h1 {
    margin-top: 20px;
  }

  p {
    color: $lighter-black;
    line-height: 30px;
    font-size: 16px;
  }

  .logo {
    border-radius: 50%;
    background: #19497e;
    width: 150px;
    height: 150px;
  }
}
</style>
